// -----------------------------------------------------------------------------
// Social-proof promo buyers for the Buy Credit page.
//
// These are marketing/demo entries shown BESIDE the real recent-buyers feed on the
// buy-credit page. They are NOT real users: they never touch real data, never hit the
// backend, and are NOT included in the "today / this month" buyer count numbers (those
// stay 100% real). Only the rotating "recently bought" names card is augmented.
//
// Behaviour: 2 entries per 30-minute slot (48 slots/day). The POOL_SIZE (240) buyers step
// two at a time and wrap after 120 slots ≈ 60 hours (~2.5 days), so a given name isn't seen
// again for ~2.5 days. (Raise POOL_SIZE to 480 for a full 5-day no-repeat window.)
//
// The first 30 buyers are hand-curated; the rest are GENERATED deterministically (no random,
// no Date) so the pool is byte-identical in every browser — required for consistent social
// proof and a stable slot→pair mapping. All generated shops use non-owner IT / computer /
// studio names, and the overall gender mix is ~95% male / ~5% female.
//
// Each surfaced buyer is { fullName, shopName, district, credits }. No `avatar` on purpose →
// the card falls back to a coloured initial. Purchase credit is fixed at PROMO_CREDITS (5600).
// -----------------------------------------------------------------------------

const PROMO_CREDITS = 2200;   // fixed "total buy credit" shown for every promo buyer
const POOL_SIZE = 240;        // total promo buyers (raise to 480 for a 5-day no-repeat cycle)

// --- Hand-curated first 30 (mix of owner-named and non-owner IT shops) ----------------------
const CURATED = [
    { fullName: 'মোহাম্মদ রফিকুল ইসলাম', shopName: 'রফিক কম্পিউটার',           district: 'ঢাকা'          },
    { fullName: 'আবদুল করিম',            shopName: 'বিসমিল্লাহ আইটি সেন্টার',    district: 'চট্টগ্রাম'      },
    { fullName: 'সজীব হোসেন',            shopName: 'মায়ের দোয়া ডিজিটাল স্টুডিও', district: 'রাজশাহী'        },
    { fullName: 'তানভীর হাসান',          shopName: 'নিউ স্টার ডিজিটাল',        district: 'খুলনা'         },
    { fullName: 'নাসির উদ্দিন',           shopName: 'ভাই ভাই কম্পিউটার্স',       district: 'সিলেট'         },
    { fullName: 'মাহমুদুল হাসান',        shopName: 'মাহমুদ কম্পিউটার',         district: 'বরিশাল'        },
    { fullName: 'ফারজানা ইয়াসমিন',      shopName: 'আয়েশা আইটি সলিউশন',       district: 'রংপুর'         },
    { fullName: 'রাকিবুল ইসলাম',         shopName: 'বিজয় কম্পিউটার জোন',       district: 'ময়মনসিংহ'      },
    { fullName: 'শামীম আহমেদ',           shopName: 'একুশে গ্রাফিক্স',           district: 'কুমিল্লা'       },
    { fullName: 'জাহিদ হোসেন',           shopName: 'মদিনা ফটো স্টুডিও',         district: 'বগুড়া'         },
    { fullName: 'মেহেদী হাসান',          shopName: 'মেহেদী প্রিন্টার্স',         district: 'যশোর'          },
    { fullName: 'তৌহিদুল ইসলাম',         shopName: 'বরকত আইটি সেন্টার',        district: 'দিনাজপুর'       },
    { fullName: 'আরিফুল ইসলাম',          shopName: 'স্বপ্ন কম্পিউটার',          district: 'নোয়াখালী'      },
    { fullName: 'সাব্বির আহমেদ',          shopName: 'মা ডিজিটাল সেন্টার',        district: 'ফরিদপুর'        },
    { fullName: 'নাইমুর রহমান',          shopName: 'স্মার্ট টেক',              district: 'টাঙ্গাইল'       },
    { fullName: 'রুবেল মিয়া',            shopName: 'রুবেল কম্পিউটার্স',         district: 'জামালপুর'       },
    { fullName: 'শাকিল আহমেদ',           shopName: 'আল-আমিন আইটি জোন',       district: 'পাবনা'         },
    { fullName: 'মুরাদ হোসেন',           shopName: 'সোনালী গ্রাফিক্স হাউস',      district: 'কুষ্টিয়া'       },
    { fullName: 'ইমরান খান',             shopName: 'বাংলা গ্রাফিক্স',          district: 'ফেনী'          },
    { fullName: 'হাসিবুল হাসান',         shopName: 'নূর ডিজিটাল স্টুডিও',       district: 'নরসিংদী'        },
    { fullName: 'মিজানুর রহমান',         shopName: 'ফ্রেন্ডস কম্পিউটার',        district: 'গাজীপুর'        },
    { fullName: 'আশিকুর রহমান',          shopName: 'সিটি অনলাইন সেন্টার',       district: 'নারায়ণগঞ্জ'     },
    { fullName: 'সাইফুল ইসলাম',          shopName: 'সাইফুল টেকনোলজি',          district: 'মানিকগঞ্জ'      },
    { fullName: 'নাজনীন আক্তার',         shopName: 'রাফসান কম্পিউটার্স',        district: 'ব্রাহ্মণবাড়িয়া' },
    { fullName: 'রেজাউল করিম',           shopName: 'জনতা কম্পিউটার',          district: 'চাঁদপুর'        },
    { fullName: 'তানজিল আহমেদ',          shopName: 'আধুনিক ডিজিটাল',          district: 'সিরাজগঞ্জ'      },
    { fullName: 'আশরাফুল আলম',           shopName: 'দিগন্ত ডিজিটাল স্টুডিও',     district: 'নাটোর'         },
    { fullName: 'জসীম উদ্দিন',           shopName: 'ইউনিক সাইবার ক্যাফে',      district: 'ঝিনাইদহ'        },
    { fullName: 'ফয়সাল আহমেদ',          shopName: 'ফয়সাল আইটি',             district: 'সাতক্ষীরা'      },
    { fullName: 'রায়হান কবির',           shopName: 'তাকওয়া কম্পিউটার প্রিন্ট',   district: 'লক্ষ্মীপুর'      },
];

// --- Generation parts (none of these first names overlap the curated ones) ------------------
// Surnames ordered by real-world frequency so the common ones dominate (realistic).
const MALE_FIRST = [
    'শাহিন', 'কামরুল', 'নাজমুল', 'সোহেল', 'জাহিদুল', 'মামুন', 'শহিদুল', 'আনোয়ার', 'বাবুল',
    'দেলোয়ার', 'মোস্তাফিজ', 'রাসেল', 'তারেক', 'জুয়েল', 'বিপ্লব', 'সুমন', 'রনি', 'সজল',
    'পলাশ', 'শামসুল', 'নুরুল', 'হারুন', 'ফরিদ', 'জামাল', 'কবির', 'মিলন', 'রিপন', 'শফিকুল',
    'আলমগীর', 'বেলাল', 'সাদ্দাম', 'রাজু', 'মাসুদ', 'ইকবাল', 'সেলিম',
];
const MALE_SURNAME = [
    'ইসলাম', 'হোসেন', 'রহমান', 'আহমেদ', 'উদ্দিন', 'মিয়া', 'খান', 'সরকার', 'চৌধুরী',
    'তালুকদার', 'ভূঁইয়া', 'মণ্ডল', 'শেখ', 'হক', 'আলী', 'সিদ্দিকী',
];
const FEMALE_FIRST = [
    'সালমা', 'রেহানা', 'নাসরিন', 'শিরিন', 'রোকসানা', 'তাহমিনা', 'সাবিনা', 'ফরিদা',
    'নার্গিস', 'মুন্নি', 'রুমা', 'শিউলি', 'দিলরুবা', 'আসমা',
];
const FEMALE_SURNAME = ['আক্তার', 'সুলতানা', 'বেগম', 'খাতুন', 'পারভীন', 'ইয়াসমিন'];

// All non-owner shop brands (blessing / family / child / aspirational — the BD way).
const SHOP_PREFIX = [
    'বিসমিল্লাহ', 'মায়ের দোয়া', 'মা', 'ভাই ভাই', 'বাবার দোয়া', 'আল্লাহর দান', 'মদিনা', 'নূর',
    'বরকত', 'রহমত', 'তাকওয়া', 'আল-আমিন', 'বিজয়', 'স্বপ্ন', 'একুশে', 'সোনালী', 'বাংলা',
    'জনতা', 'আধুনিক', 'দিগন্ত', 'ইউনিক', 'স্মার্ট', 'সিটি', 'নিউ স্টার', 'ফ্রেন্ডস', 'রাফসান',
    'আয়েশা', 'প্রভাতী', 'আলো', 'তারা', 'গ্রীন', 'রয়েল', 'স্টার', 'মেগা', 'প্রাইম', 'ন্যাশনাল',
    'ভিশন', 'একতা', 'বন্ধন', 'প্রিয়', 'নিউ', 'ডিজিটাল ওয়ার্ল্ড', 'সেবা', 'ভরসা',
];
const SHOP_SUFFIX = [
    'কম্পিউটার', 'কম্পিউটার্স', 'আইটি সেন্টার', 'আইটি জোন', 'ডিজিটাল স্টুডিও', 'ডিজিটাল সেন্টার',
    'গ্রাফিক্স', 'গ্রাফিক্স হাউস', 'ফটো স্টুডিও', 'প্রিন্টার্স', 'সাইবার ক্যাফে', 'অনলাইন সেন্টার',
    'টেকনোলজি', 'ডিজিটাল', 'আইটি সলিউশন',
];
const DISTRICTS = [
    'ঢাকা', 'চট্টগ্রাম', 'রাজশাহী', 'খুলনা', 'বরিশাল', 'সিলেট', 'রংপুর', 'ময়মনসিংহ', 'কুমিল্লা',
    'বগুড়া', 'যশোর', 'দিনাজপুর', 'নোয়াখালী', 'ফরিদপুর', 'টাঙ্গাইল', 'জামালপুর', 'পাবনা', 'কুষ্টিয়া',
    'ফেনী', 'নরসিংদী', 'গাজীপুর', 'নারায়ণগঞ্জ', 'মানিকগঞ্জ', 'ব্রাহ্মণবাড়িয়া', 'চাঁদপুর', 'সিরাজগঞ্জ',
    'নাটোর', 'ঝিনাইদহ', 'সাতক্ষীরা', 'লক্ষ্মীপুর', 'মৌলভীবাজার', 'হবিগঞ্জ', 'সুনামগঞ্জ', 'নওগাঁ',
    'চাঁপাইনবাবগঞ্জ', 'জয়পুরহাট', 'গোপালগঞ্জ', 'মাদারীপুর', 'শরীয়তপুর', 'রাজবাড়ী', 'কিশোরগঞ্জ',
    'নেত্রকোনা', 'শেরপুর', 'বরগুনা', 'ভোলা', 'পটুয়াখালী', 'পিরোজপুর', 'ঝালকাঠি', 'মেহেরপুর',
    'চুয়াডাঙ্গা', 'মাগুরা', 'নড়াইল', 'বাগেরহাট', 'ঠাকুরগাঁও', 'পঞ্চগড়', 'নীলফামারী', 'লালমনিরহাট',
    'কুড়িগ্রাম', 'গাইবান্ধা', 'রাঙ্গামাটি', 'বান্দরবান', 'খাগড়াছড়ি', 'কক্সবাজার',
];

// Build the full pool deterministically: curated 30 first, then generated buyers until we
// reach POOL_SIZE. ~1 in 20 is female (spread out); full names are de-duped so no name ever
// repeats within the pool (→ no repeat within a rotation cycle). Pure function of the index —
// no Date, no random — so every browser computes the exact same list.
function buildPool() {
    const pool = [...CURATED];
    const seen = new Set(pool.map(b => b.fullName));
    let mi = 0, fi = 0;
    while (pool.length < POOL_SIZE) {
        const idx = pool.length;
        let fullName;
        if (idx % 20 === 9) {                                   // ~5% female, evenly spread
            fullName = `${FEMALE_FIRST[fi % FEMALE_FIRST.length]} ${FEMALE_SURNAME[fi % FEMALE_SURNAME.length]}`;
            fi++;
        } else {
            fullName = `${MALE_FIRST[mi % MALE_FIRST.length]} ${MALE_SURNAME[Math.floor(mi / MALE_FIRST.length) % MALE_SURNAME.length]}`;
            mi++;
        }
        if (seen.has(fullName)) continue;                        // deterministic skip on collision
        seen.add(fullName);
        const shopName = `${SHOP_PREFIX[idx % SHOP_PREFIX.length]} ${SHOP_SUFFIX[(idx * 7 + 3) % SHOP_SUFFIX.length]}`;
        pool.push({ fullName, shopName, district: DISTRICTS[idx % DISTRICTS.length] });
    }
    return pool;
}

export const PROMO_BUYERS = buildPool();

const PER_SLOT = 2;                                  // promo buyers surfaced per 30-min slot
const PAIRS = PROMO_BUYERS.length / PER_SLOT;        // 240 ÷ 2 = 120 pairs, then wraps
const SLOT_MS = 30 * 60 * 1000;                      // promo pair changes every 30 minutes

// Current 30-minute slot index (whole 30-min windows since the Unix epoch). Increments once
// every 30 minutes and is identical for everyone in the same window. 30 min divides evenly
// into the day, so slot boundaries land on :00 / :30 clock times (in every whole-hour-offset
// timezone, including Dhaka's UTC+6).
export function currentSlotIndex(date = new Date()) {
    return Math.floor(date.getTime() / SLOT_MS);
}

// The 2 promo buyers for a given slot, each with the fixed 5600 credit. Consecutive slots
// step through the pairs (0→[0,1], 1→[2,3], …) and wrap, so all 240 buyers cycle every
// 120 × 30 min = 60 hours (~2.5 days) before any name is shown again.
export function getFakeBuyersForSlot(slotIndex) {
    const pair = ((slotIndex % PAIRS) + PAIRS) % PAIRS;
    const start = pair * PER_SLOT;
    return PROMO_BUYERS.slice(start, start + PER_SLOT).map(b => ({ ...b, credits: PROMO_CREDITS }));
}

// Merge this slot's 2 promo buyers INTO the real buyers list, spread apart (never back-to-
// back) so the rotation looks natural: the reals are split into (fakes + 1) even-ish chunks
// with a promo buyer dropped between them → e.g. real, fake, real, real, fake, real. Real
// order is preserved and the inputs are never mutated. With 0–1 real buyers the two fakes may
// end up adjacent (unavoidable — there aren't enough reals to separate them).
export function withFakeBuyers(realBuyers = [], slotIndex = currentSlotIndex()) {
    const fakes = getFakeBuyersForSlot(slotIndex);
    if (!realBuyers.length) return fakes;
    const groups = fakes.length + 1;
    const chunk = realBuyers.length / groups;
    const out = [];
    let r = 0;
    for (let g = 0; g < groups; g++) {
        const end = g === groups - 1 ? realBuyers.length : Math.floor((g + 1) * chunk);
        for (; r < end; r++) out.push(realBuyers[r]);
        if (g < fakes.length) out.push(fakes[g]);
    }
    return out;
}
